export default "__VITE_ASSET__DEhJsHaf__"